// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".L2Yke5ssxkCQ9gd0cScc{height:100%}", "",{"version":3,"sources":["webpack://./src/uikit/containers/UikPageFade/PageFade.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA","sourcesContent":[".animationWrapper {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animationWrapper": "L2Yke5ssxkCQ9gd0cScc"
};
export default ___CSS_LOADER_EXPORT___;
